import * as requestFromServer from "./containerCrud";
import { containerSlice, callTypes } from "./containerSlice";

const { actions } = containerSlice;
// Tags each request for a franchise's container list so only the newest one
// may write to the store. Sorting a column twice in quick succession fires two
// requests, and without this the earlier response can land last and leave the
// table in the previous order under the new arrow.
let containerFranchiseRequestId = 0;

/**
 * Fetch a franchise's containers, discarding a response a newer request has
 * superseded.
 *
 * @param {Object} queryParams Filters, paging and sort for the list endpoint
 * @returns {function(Function): Promise<void>} Thunk
 */
export const fetchContainerFranchise = (queryParams) => (dispatch) => {
  const requestId = ++containerFranchiseRequestId;

  dispatch(actions.startCall({ callType: callTypes.list, requestId }));
  return requestFromServer
    .getContainerFranchise(queryParams)
    .then((response) => {
      const { data, meta } = response.data;

      dispatch(actions.ContainerFetchedFranchise({ requestId, data: data, totalCount: meta.total, }));

    })
    .catch((error) => {
      error.clientMessage = "Can't find products";
      dispatch(actions.catchError({ error, callType: callTypes.list, requestId }));
    });
};

// The Settings > Containers table sorts and pages on the server too
// (`remote` + onTableChange), so it has the same race. Its own counter, kept
// separate from the franchise list above because the two write to different
// parts of the store.
let containerListRequestId = 0;

/**
 * Fetch the container list, discarding a response a newer request has
 * superseded.
 *
 * @param {Object} queryParams Filters, paging and sort for the list endpoint
 * @returns {function(Function): Promise<void>} Thunk
 */
export const fetchContainerList = (queryParams) => (dispatch) => {
  const requestId = ++containerListRequestId;

  dispatch(actions.startCall({ callType: callTypes.listAll, requestId }));
  return requestFromServer
    .containerList(queryParams)
    .then((response) => {
      const { meta, data } = response.data;

      dispatch(
        actions.ContainerFetchedList({
          requestId,
          totalCount: meta.total,
          entities: data,
        })
      );
    })
    .catch((error) => {
      error.clientMessage = "Can't find products";
      dispatch(
        actions.catchError({ error, callType: callTypes.listAll, requestId })
      );
    });
};


